import React from 'react'

function Profile() {
  return (
    <div>my Profile page</div>
  )
}

export default Profile